import { getColor } from '.'
import { css } from '@emotion/core'
import { ThemeColorName } from '../types'

export const makeBgStyle = (themeColor: ThemeColorName) => css`
  background-color: ${getColor(themeColor)};
`
